export default {
    APP_ID: process.env.VUE_APP_ID, // 应用ID
    APP_PUBLIC_ROUTER_JSON: process.env.VUE_APP_PUBLIC_ROUTER_JSON, // 公共路由
    APP_NAME: 'ucenter',
    PictureSize: '长230、宽130',
    WEB_ID: 'yushuhappystudyweb',
    Settings: {},
    CustomerType: {
        Power: 0x01, // 发电类型企业
        Loader: 0x02, // 负荷类型企业
        EnergyStorage: 0x04 // 储能类型企业
    },
    // TEMPLATE_FILE_KEY: {
    //     USER_IMPORT: 'template_user_import.xls',
    //     SENSITIVE_WORDS_IMPORT: 'template_sensitivewords_import.xlsx',
    // },
    UploadFileType: {
        PICTURE: '.jpg,.jpeg,.png,.pneg,.gif',
        VIDEO: 'video/wmv,video/wm,video/asf,video/asx,video/rm,video/mpg,video/mpeg,video/3gp,video/mp4,video/rmvb,video/mkv,video/avi,video/flv,video/f4v,video/x-ms-wmv',
        AUDIO: 'MP3,WAV,WMA,MIDI,AAC,MOV',
        excel: '.xls,.xlsx',
        doc: '.doc,.docx,.pdf,.ppt,.xls,.xlsx'
    },
    ERROR_COEE: {
        USER_LOGIN_ERROR: 40001,
        ERROR_UNLOGIN_USER: -22,
        ERROR_FORCE_LOGIN: -23,
        ERROR_NONE_TOKEN: -24,
        ERROR_SERVER_TOKEN_ERROR: -26,
        ERROR_NO_THEME: 9503
    },
    Code: {
        WEIBO_URL: 'https://weibo.com/6096053589',
        WeixinPubQrImageUrl: '//samples/qrcode.jpg', // 微信公众号二维码Url
        LOGIN_TYPE_ACCOUNT: 'account', // 登录类型：-账号密码登录
        LOGIN_TYPE_VERIFYCODE: 'verifyCode', // 登录类型：-手机验证码登录
        LOGIN_TYPE_WXKFPTSCAN: 'wxkfptqrscan', // 登录类型：-手机验证码登录
        REG_BY_PHONE: 'pcPhone', // PC端-手机号码注册
        REG_BY_WX: 'pcWx', // PC-微信注册
        REG_BY_WXMA: 'wxma', // 微信小程序一键登录注册
        REG_BY_APP: 'app', // app注册
        AUDIT_WAITING: '0', // 待审核
        AUDIT_APPROVED: '1', // 审核通过
        AUDIT_REJECT: '2', // 已驳回
        TranscodeProvider: '111', // 转码服务提供者维度
        TRANSCODE_TYPE_ALIYUN: 'aliyunTranscodeProvider',
        TRANSCODE_TYPE_YUSHU: 'yushuTranscodeProvider',
        LOGIN_METHODS: '126', // 登录方式
        LOGIN_METHODS_USER: 'user', // 账号密码方式登录
        LOGIN_METHODS_WEIXIN: 'weixin', // 微信扫码登录
        LOGIN_METHODS_QQ: 'qq', // QQ方式登录
        LOGIN_METHODS_QRCODE: 'qrcode', // 本APP扫码登录
        VERIFY_CODE_FindPassword: 'FindPassword', // 找回密码
        VERIFY_CODE_ResetPassword: 'ResetPassword', // 重置密码
        VERIFY_CODE_Register: 'Register', // 注册
        VERIFY_CODE_Login: 'Login', // 登录
        VERIFY_CODE_ModifyUserName: 'ModifyUserName', // 修改用户名
        VERIFY_CODE_ResetPhone: 'ResetPhone', // 修改手机号码
        VERIFY_CODE_BindPhone: 'BindPhone', // 绑定手机
        VERIFY_CODE_LENGTH: 6, // 手机验证码默认长度
        FILE_TYPE_VIDEO: 'VIDEO', // 视频
        FILE_TYPE_AUDIO: 'AUDIO', // 文档
        FILE_TYPE_DOC: 'DOC', // 图片
        FILE_TYPE_PIC: 'PIC', // 图片
        FILE_TYPE_OTHERS: 'OTHERS', // 其他类型
        ResourceType: { VIDEO: "1", AUDIO: "2", DOC: "4", PIC: "21", OTHERS: "22" },
        CHANNEL_TYPE_Article: "Article", // 图文文章
        CHANNEL_TYPE_Picture: "Picture", // 图文
        CHANNEL_TYPE_Text: "Text", // 文本
        CHANNEL_TYPE_Banner: "Banner", // 轮播图
        CHANNEL_TYPE_Link: "Link", // 链接
    },
    ResourceIcon: {
        'iconfont icon-yushuexcel': 'jpg, jpeg, png, pneg,bmp,gif',
        'fa fa-video-camera': 'wmv,wm,asf,asx,rm,ram,mpg,mpeg,3gp,mp4,rmvb,mkv,avi,flv,f4v,vob',
        'yushuexcel': 'xls,xlsx',
        'fa fa-file-pdf-o': 'pdf',
        'el-icon-s-cooperation': 'jar,zip,gzip,7zip,tar,rar',
        'fa-file-word-o': 'doc,docx',
        'others': 'el-icon-tickets'
    },
    DictionaryType: {},
    Identity: {
        User: 'user'
    },
    FileManager: {
        URI: '/api/storage/resources/filedownload',
        preview(id) {
            return Constants.FileManager.URI + `?isAttachement=false&unique=${id}`;
        }
    },
    DataDic: {
        WidgetType: {
            YesOrNo: 'YesOrNo',
            SingleLineText: 'SingleLineText', // 单行文字
            MultiLineText: 'MultiLineText', // 多行文字
            Radio: 'Radio', // Radio单选
            CheckBox: 'CheckBox', // Check多选
            DropdownSelect: 'DropdownSelect', // Select下拉
            Cascader: 'Cascader', // 级联下拉选择
            MultiLevelDropdownSelect: 'MultiLevelDropdownSelect', // 多级下拉
            SingleImageUpload: 'SingleImageUpload', // 图片单选
            MultiImageUpload: 'MultiImageUpload', // 图片多选
            Number: 'Number', // 数字
            UploadFile: 'UploadFile', // 上传文件
            Time: 'Time', // 时间
            Date: 'Date', // 日期 
            DateTime: 'DateTime', // 日期时间
            Website: 'Website', // 网址
            Geography: 'Geography', // 地理位置
            FullName: 'FullName', // 姓名
            MobileNumber: 'MobileNumber', // 手机
            PhoneNumber: 'PhoneNumber', // 电话
            Email: 'Email', // 邮箱
            Address: 'Address', // 地址
            Compose: 'Compose', // 组合，自定义模式,
            RichTextEditor: 'RichTextEditor', // 富文本编辑器,
            Area: 'Area' // 地区
        }
    },
};